import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { LeadsAction } from "stores/Leads/LeadsAction";
import { commonActions } from "stores/common/commonActions";

const mapStateToProps = (state) => {
    return {
        leadsDataList: state.LeadsData.leadsDataList,
        isLoading: state.LeadsData.isLoading,
        OwnerListData:state.common.OwnerListData,
        HostListData:state.common.HostListData
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
   
    getLeadsAction: LeadsAction.getLeadsAction,
    getOwnerListDataAction: commonActions.getOwnerListData,
    getHostListDataAction: commonActions.getHostListData
}, dispatch);

const LeadRequestStore = (Container) => connect(mapStateToProps, mapDispatchToProps)(Container);
export default LeadRequestStore;